import React, { Component } from 'react';
import * as API from './api.js';
import CustomersInactive from './customers.png';
import Loader from './icons/loader.svg';
import Users from './users.png';
import UsersStats from './res/stats.png'
import Search from "./Icon/Search.png";
import service from "./sidebaricon/Services.png";
import dateFormat from 'dateformat';
import { Link, StaticRouter, Redirect } from 'react-router-dom';
import SideBar from './SideBar';
import install from './icons/AeroGCSInactive.png'
import TaskIcon from './icons/servers.png'
import SupportIcon from './icons/support.png'
import logList from './icons/logList.png'
import logListActive from './icons/logsActive.png'
import StatsInactive from './sidebaricon/StatsInactive.svg'
import detectors from './icons/detector.png'
import { SortComponent } from './ReusableComponents/SortComponent.js';
import { DeleteComponentGrid } from './ReusableComponents/Menu.js';
import { Popup } from './ReusableComponents/reusableFunctions.js';
import { getAllUsersUsageSummary } from './api.js';
import TopBar from './TopBar.js';
export default class AdminActivityLogs extends Component {
    state = {
        user: {},
        type: "",
        logs: [],
        currentpage: 1,
        logsperpage: 18,
        key: " ",
        loading: false,
        fromDate: '',
        toDate: '',
        successParams: {
            title: "ADMIN LOGS",
            message1: "Viewing admin activity logs",
            message2: "To go back to users, click",
            hereLink: "/admin/users",
            buttonText: "Back to Users",
            buttonLink: "/admin/users"
        },
        sidebarMode: (this.props.location.state ? this.props.location.state.sidebarMode : "shrunk"),
        userAnalytic: false,
        sortBy: 'created_at',
        sort: 'desc',
        uStatusType: 'all',
        searchByDate: {
            fromDate: '',
            toDate: new Date()
        },
        analytics: null,
        userFilterType: 'all',
        plans: [],
        userStatusType: 'all'
    }

    initDate = () => {
        return {
            fromDate: '',
            toDate: new Date()
        };
    }

    parentSidebarSwitch = () => {
        this.setState((state) => ({
            ...state,
            sidebarMode: (state.sidebarMode == "shrunk" ? "expanded" : "shrunk")
        }))
    }

    onChangeListener = (e) => {
        let t = e.target;
        this.setState((state) => ({
            ...state,
            [t.name]: t.value
        }))
    }
    getAdminLogs = async () => {
        try {
            this.setState({ loading: true });
            const { key, currentpage, logsperpage, searchByDate, sortBy, sort } = this.state;
            const lastIndex = currentpage * logsperpage;
            const firstpage = lastIndex - logsperpage;

            let fd = searchByDate.fromDate ? new Date(searchByDate.fromDate).toISOString() : null;
            let td = new Date(searchByDate.toDate);
            td.setHours(td.getHours() + 23);
            td.setMinutes(td.getMinutes() + 59);
            td.setSeconds(td.getSeconds() + 59);

            const response = await API.getAdminActivityLogs(
                key === "" ? " " : key,
                firstpage,
                logsperpage,
                fd,
                td.toISOString()
            );

            this.setState({
                logs: response.data,
                counts: response.total,
                loading: false
            });
        } catch (error) {
            console.error('Error fetching logs:', error);
            this.setState({ loading: false });
        }
    }

    componentWillMount() {
        document.title = "Admin Logs";
        if (this.props.location.state) {
            let { user, type } = this.props.location.state;
            this.initDate()
            this.setState((state) => ({
                ...state,
                user,
                type
            }), () => {
                this.getAdminLogs()
            })
        } else {
            API.getUserType().then(([blah, type, user]) => {
                this.setState((state) => ({
                    ...state,
                    user,
                    type
                }), () => {
                    this.getAdminLogs()
                })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }

    successRedirectComponent = () => {
        if (this.state.redirect) {
            return <Redirect to={{
                pathname: "/success",
                state: {
                    ...this.state.successParams,
                    user: this.state.user,
                    type: this.state.type,
                    sidebarMode: this.state.sidebarMode
                }
            }} />
        }
    }

    sort = (sortBy, sort) => {
        this.setState({ sortBy, sort }, () => {
            this.getAdminLogs()
        })
    }

    firstpage = () => {
        if (this.state.currentpage > 1) {
            this.setState((state) => ({
                ...state,
                currentpage: 1
            }), () => { this.getAdminLogs(); });
        } else console.log("Reached last page")
    }

    prevpage = () => {
        if (this.state.currentpage > 1) {
            this.setState((state) => ({
                ...state,
                currentpage: this.state.currentpage - 1
            }), () => { this.getAdminLogs() });
        }
    }

    nextpage = () => {
        if (this.state.currentpage < Math.ceil(this.state.counts / this.state.logsperpage)) {
            this.setState((state) => ({
                ...state,
                currentpage: state.currentpage + 1
            }), () => { this.getAdminLogs() });
        } else console.log("Reached last page")
    }

    lastpage = () => {
        if (this.state.currentpage < Math.ceil(this.state.counts / this.state.logsperpage)) {
            this.setState((state) => ({
                ...state,
                currentpage: Math.ceil(this.state.counts / state.logsperpage)
            }), () => { this.getAdminLogs() });
        } else console.log("Reached last page")
    }

    getSubbedServices = () => {
        API.getUserSubbedServices().then((services) => {
            let names = services[0].map((service) => { return service.title })
            if (names.findIndex(data => data == "Analytic Tool") != -1) {
                this.setState((state) => ({
                    ...state,
                    userAnalytic: true
                }));
            }
        }).catch(err => { this.setState({ userAnalytic: false }) })
    };

    changepage(num) {
        if (isNaN(num)) return null;
        else {
            this.setState((state) => ({
                ...state,
                currentpage: num,
            }), () => this.getAdminLogs());
        }
    }

    search = (key) => {
        this.setState((state) => ({
            ...state,
            key,
            currentpage: 1
        }), () => this.getAdminLogs());
    }

    resetFilters = () => {
        this.setState({
            searchByDate: { fromDate: '', toDate: new Date() },
            key: '',
            currentpage: 1
        }, () => {
            this.getAdminLogs();
        });
    }

    formatActionType = (actionType) => {
        const actionTypeMap = {
            'USER_DELETE': { text: 'Delete User', isDangerous: true },
            'USER_CREATE': { text: 'Create User', isDangerous: false },
            'USER_UPDATE': { text: 'Update User', isDangerous: false },
            'PLAN_UPDATE': { text: 'Update Plan', isDangerous: false },
            'CREDIT_UPDATE': { text: 'Update Credits', isDangerous: false },
            'SUBSCRIPTION_CANCEL': { text: 'Cancel Subscription', isDangerous: true },
            'SUBSCRIPTION_UPDATE': { text: 'Update Subscription', isDangerous: false },
            'PROJECT_DELETE': { text: 'Delete Project', isDangerous: true },
            'TASK_DELETE': { text: 'Delete Task', isDangerous: true }
        };

        const action = actionTypeMap[actionType] || { text: actionType.replace(/_/g, ' ').toLowerCase(), isDangerous: false };
        return (
            <span style={{
                color: action.isDangerous ? '#FF4D4F' : '#000000',
                fontWeight: action.isDangerous ? '500' : 'normal'
            }}>
                {action.text}
            </span>
        );
    }

    render() {
        const { user, type, logs, currentpage, logsperpage, counts, loading } = this.state;
        let sidebarConfigurations = {
            options: [
                {
                    icon: service,
                    text: "Services",
                    path: "/"
                },
                {
                    icon: UsersStats,
                    text: "Statistics",
                    path: "/admin/users_stats",
                },
                {
                    icon: CustomersInactive,
                    text: "Add NPNT Customer",
                    path: "/admin/add_npnt_customer"
                },
                {
                    icon: Users,
                    text: "Users",
                    path: "/admin/users",
                },
                {
                    icon: install,
                    text: "Installations",
                    path: "/admin/gcs-installation",
                },
                {
                    icon: TaskIcon,
                    text: "Tasks",
                    path: "/admin/tasks",
                },
                {
                    icon: logList,
                    text: "Task Logs",
                    path: "/admin/taskLogs",
                },
                {
                    icon: logListActive,
                    text: "Admin Activity Logs",
                    path: "/admin/activityLogs",
                    selected: true
                },
                {
                    icon: detectors,
                    text: "Detectors",
                    path: "/admin/detectors"
                },
                {
                    icon: SupportIcon,
                    text: "Support",
                    path: "/admin/supportEmails",
                },
                {
                    icon: StatsInactive,
                    text: "Stats",
                    path: "/admin/system_monitoring",
                },
            ],
            user,
            type,
            mode: this.state.sidebarMode
        }

        return (
            this.state.user && this.state.user.first_name ?
                <div className="wrapper">
                    <SideBar
                        config={sidebarConfigurations}
                        parentSidebarSwitch={this.parentSidebarSwitch}
                    />
                    <div className="right-content" onClick={() => {
                        this.setState((state) => ({
                            ...state, sidebarMode: 'shrunk'
                        }))
                    }}>
                        {/* <div className="top-bar" style={{ display: "flex" }}><div className="top-bar-text">
                            ADMIN ACTIVITY LOGS
                        </div>
                        </div> */}
                        <TopBar title='ADMIN ACTIVITY LOGS' />

                        <div className="main-content" style={{ paddingTop: "16px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", margin: "16px 0" }}>
                                <div style={{ display: "flex", width: "100%" }}>
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', gap: '10px' }}>
                                        <div className="add-user-form-row-left" >
                                            <div className="add-user-form-text-wrapper" style={{ display: "flex", alignItems: "center" }} >
                                                <label style={{ color: "#666666", fontFamily: "Poppins", fontSize: "12px", margin: 0 }}>From :</label>
                                                <input
                                                    className="add-user-form-text"
                                                    type="date"
                                                    max='9000-01-01'
                                                    value={this.state.searchByDate.fromDate}
                                                    onChange={(event) => this.setState({
                                                        searchByDate: { ...this.state.searchByDate, fromDate: event.target.value }
                                                    }, () => { this.getAdminLogs() })}
                                                    style={{
                                                        borderRadius: '10px',
                                                        marginLeft: "8px",
                                                        height: "30px",
                                                        width: "125px",
                                                        cursor: "pointer"
                                                    }} />
                                            </div>
                                        </div>
                                        <div className="add-user-form-row-left" style={{ marginLeft: "20px" }}>
                                            <div className="add-user-form-text-wrapper" style={{ display: "flex", alignItems: "center" }} >
                                                <label style={{ color: "#666666", fontFamily: "Poppins", fontSize: "12px", margin: 0 }}>To :</label>
                                                <input
                                                    className="add-user-form-text"
                                                    type="date"
                                                    max='9000-01-01'
                                                    value={this.state.searchByDate.toDate}
                                                    onChange={(event) => this.setState({
                                                        searchByDate: { ...this.state.searchByDate, toDate: event.target.value }
                                                    }, () => { this.getAdminLogs() })}
                                                    style={{
                                                        backgroundColor: "white",
                                                        marginLeft: "8px",
                                                        borderRadius: '10px',
                                                        outline: "none",
                                                        height: "30px",
                                                        cursor: "pointer",
                                                        width: "125px",
                                                    }} />
                                            </div>
                                        </div>
                                        <span
                                            style={{
                                                marginLeft: '10px',
                                                color: '#2989cf',
                                                textDecoration: 'underline',
                                                background: 'none',
                                                border: 'none',
                                                cursor: 'pointer',
                                                fontSize: '13px',
                                                fontFamily: 'Poppins',
                                                padding: 0
                                            }}
                                            onClick={this.resetFilters}
                                        >
                                            Reset Filters
                                        </span>
                                    </div>

                                    <div className="add-user-form-row-left" style={{ marginLeft: "auto", display: 'flex', alignItems: 'center' }}>
                                        <div className="add-user-form-text-wrapper">
                                            <img src={Search} style={{ height: "20px", width: "20px", position: 'relative', left: '25px' }} />
                                            <input type="text" className="add-user-form-text" placeholder="Search Logs" style={{ height: '28px', width: "200px", paddingLeft: '28px', fontSize: '13px', borderRadius: '6px' }} onChange={(event) => this.search(event.target.value)} value={this.state.key == " " ? "" : this.state.key} />
                                        </div>

                                    </div>
                                </div>
                            </div >

                            <div style={{ height: 'calc(100% - 225px)', position: "absolute", width: 'calc(100% - 57px)', overflow: 'auto' }}>
                                <table className="customers-table" style={{ marginTop: "0px" }}>
                                    <thead>
                                        <tr className="customers-table-header-row">
                                            <th>Admin</th>
                                            <th>Action Type</th>
                                            <th>IP Address</th>
                                            <th>Date</th>
                                            <th>Details</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr className="customers-table-data-row" align="center" style={{ height: "45px" }}>
                                                <td colSpan="6">
                                                    <div style={{
                                                        height: "7vh",
                                                        display: "flex",
                                                        textAlign: "center",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                    }}>
                                                        <img src={Loader} style={{ position: "relative", height: "10vh" }} alt="loading" />
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : logs.length === 0 ? (
                                            <tr className="customers-table-data-row" align="center" style={{ height: "45px" }}>
                                                <td colSpan="6">No Logs Available</td>
                                            </tr>
                                        ) : (
                                            logs.map((log) => (
                                                <tr key={log.id} className="customers-table-data-row" style={{ height: "45px" }}>
                                                    <td>{log.admin_first_name} {log.admin_last_name} ({log.admin_username})</td>
                                                    <td>{this.formatActionType(log.action_type)}</td>
                                                    <td>{log.ip_address}</td>
                                                    <td>{dateFormat(log.created_at, 'dd mmm yyyy hh:MM:ss TT')}</td>
                                                    <td>
                                                        <pre style={{ maxWidth: '300px', whiteSpace: 'pre-wrap', margin: 0 }}>
                                                            {JSON.stringify(log.action_details, null, 2)}
                                                        </pre>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            {
                                !loading && <footer className="footer" style={{
                                    height: '50px',
                                    visibility: (this.state.counts > this.state.logsperpage ? "visible" : "hidden"),
                                    position: "absolute",
                                    bottom: "10px",
                                    width: "calc(100% - 57px)"
                                }}>
                                    <div style={{ float: "left", display: "flex" }}>
                                        <div style={{ color: "#109cf1", marginTop: "11px", fontSize: "13px", fontFamily: "Poppins", fontStyle: "normal", fontWeight: "600" }} >
                                            Page : {currentpage}
                                        </div>
                                    </div>
                                    <div style={{ float: "right", display: "flex" }}>
                                        <button style={{ padding: "0", outline: "none", border: "none", background: "#F5F6F8", color: "#109cf1", }} onClick={this.firstpage}>
                                            <div className="add-user-form-submit-button" >
                                                First
                                            </div>
                                        </button>
                                        <button style={{ padding: "0", outline: "none", border: "none", background: "#F5F6F8", color: "#109cf1", marginRight: "10px", marginLeft: "10px" }} onClick={this.prevpage}>
                                            <div className="addcustomer-button-empty-dashboard" >
                                                Prev
                                            </div>
                                        </button>
                                        <form>
                                            <div style={{ display: "flex" }}>
                                                <div className="add-user-form-label" style={{ color: "#109cf1", marginTop: "7px", fontSize: "13px", fontFamily: "Poppins", fontStyle: "normal", fontWeight: "600" }}>
                                                    Go to page :
                                                </div>
                                                <div className="add-user-form-text-wrapper">
                                                    <input type="text" className="add-user-form-text" style={{ height: "40px", width: "40px", textAlign: "center", color: "#109cf1", fontSize: "13px", marginLeft: "5px", backgroundColor: "#F5F6F8" }}
                                                        onKeyPress={(event) => { if (event.key === "Enter") { event.preventDefault(); } }}
                                                        onChange={(event) => this.changepage(parseInt(event.target.value))} name="currentpage" value={currentpage} />
                                                </div>
                                            </div>
                                        </form>

                                        <button style={{ padding: "0", outline: "none", border: "none", background: "#F5F6F8", marginLeft: "15px", color: "#109cf1", marginLeft: "10px" }} onClick={this.nextpage}>
                                            <div className="addcustomer-button-empty-dashboard" >
                                                Next
                                            </div>
                                        </button>
                                        <button style={{ padding: "0", outline: "none", border: "none", background: "#F5F6F8", color: "#109cf1", marginLeft: "10px" }} onClick={this.lastpage}>
                                            <div className="add-user-form-submit-button" >
                                                Last
                                            </div>
                                        </button>

                                    </div>


                                </footer>
                            }
                        </div>
                    </div >
                </div> :
                <div style={{ height: "85vh", width: "91vw", display: "flex", textAlign: "center" }}>
                    <img src={Loader} style={{ height: "30vh", width: "100vw", margin: "auto" }} alt="loading" />
                </div>
        );
    }
}